<template>
    <v-dialog persistent v-model="dialog" width=70%>
        <v-card class="px-2">
            <v-container>
                <v-card-title>Send review</v-card-title>
                <v-card-text>
                    <v-row cols="12">
                        <v-col cols="4">
                            <v-select v-model="contact" :items="contacts" item-value="eign_code" item-text="description" label="Send this review to" dense clearable>
                            </v-select>
                        </v-col>
                        <v-col cols="7">
                            <div v-if="this.contact!=='' && this.contact!==null">
                                <v-text-field v-model="sendto" label="E-mail address" clearable dense>
                                </v-text-field>                                
                            </div>   
                        </v-col>
                        <v-col cols="1">
                            <div v-if="this.contact!=='' && this.contact!==null">
                                <v-text-field v-model="sendtolng" label="Language" readonly dense>
                                </v-text-field>                                
                            </div>   
                        </v-col>                        
                    </v-row>
                    <v-row cols="12">
                        <v-col cols="4">
                            <v-text-field v-model="sender_address" label="Sender" dense>
                            </v-text-field>
                        </v-col>                        
                        <v-col cols="8">
                            <v-text-field v-model="mail_subject" label="Subject" dense>
                            </v-text-field>
                        </v-col>
                    </v-row>  
                    <div v-if="review.table === 'hogr'">
                        <ul class="ul_style">
                            <li>
                                <v-layout justify-start>
                                    <v-textarea v-model="mail_text" label="mail text" auto-grow
                                        class="pl-11 mr-2 ml-1" counter no-resize>
                                    </v-textarea>
                                </v-layout>                    
                            </li>                            
                            <li>
                                <v-layout justify-start>
                                    <span style="vertical-align: top;" class="pl-3 pt-4">
                                        <v-simple-checkbox small v-model="send_review"></v-simple-checkbox>
                                    </span>
                                    <v-textarea v-model="display_review" label="Review text" auto-grow
                                        class="mr-2 ml-1" counter no-resize>
                                    </v-textarea>
                                </v-layout>                    
                            </li>
                            <li>
                                <v-layout justify-start>
                                    <span style="vertical-align: top;" class="pl-3 pt-4">
                                        <v-simple-checkbox small v-model="send_tipshost"></v-simple-checkbox>
                                    </span>
                                    <v-textarea v-model="display_tips" label="Tips for the host" auto-grow
                                        class="mr-2 ml-1" counter no-resize>
                                    </v-textarea>
                                </v-layout>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <ul class="ul_style">
                            <li>
                                <v-layout justify-start>
                                    <v-textarea v-model="mail_text" label="mail text" auto-grow
                                        class="mr-2 ml-1" counter no-resize>
                                    </v-textarea>
                                </v-layout>                    
                            </li>                                   
                            <li>
                                <v-layout justify-start>
                                    <span style="vertical-align: top;" class="pl-3 pt-4">
                                        <v-simple-checkbox small v-model="send_review"></v-simple-checkbox>
                                    </span>
                                    <v-textarea v-model="display_review" label="Review text" auto-grow
                                        class="mr-2 ml-1" counter no-resize>
                                    </v-textarea>
                                </v-layout>
                            </li>
                        </ul>
                    </div>
                   </v-card-text>
            </v-container>
            <v-card-actions>
                <v-spacer />
                <v-btn :color="has_text" v-bind:disabled="loading || !can_send" v-bind:loading="loading" v-on:click="sendReview(true)" small class="mb-2">
                    <v-icon left>mdi-email-fast-outline</v-icon>Send e-mail
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                </v-btn>                
                <v-btn color="primary" v-on:click="sendReview(false)" :disabled="!can_send" small class="mb-2">
                    <v-icon left>mdi-email-search-outline</v-icon>Preview e-mail
                </v-btn>
                <v-btn color="primary" small v-on:click="closeDialog()" class="mr-3 mb-2">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>


import { bus } from "../../../../main";
import mxfindwithattribute from '@/mixins/findwithattribute';

export default {    
    data() {
        return {
            dialog: false,
            loading: false,
            contact: '',
            sendto: '',
            sendtolng: '',
            sender_address: '',
            mail_subject: '',
            send_review: false,
            send_tipshost: false,
            mail_text: '',
            mail_text_html: '',
            mail_review_html: '',
            mail_tips_html: '',
            display_review: '',
            display_tips: '',
            review_texts: [],
            review_tips: [],
            contacts: [],
            review: {},
        }
    },
    watch: {
        contact() {
            this.getContactEmail();
            this.getContactLanguage();
            this.getContactEmailSubject();
        },
    },
    created() {

    },
    mixins: [mxfindwithattribute],
    computed: {
        contact_lng: function(){
            var idx = this.findWithAttr(this.contacts, "eign_code", this.contact); // code, name zoeken in, naar, met waarde
            if(idx!==-1){
                return this.contacts[idx].eign_taal;
            } else {
                return '';
            }
        },
        can_send: function () {
            if (this.mail_subject !== '' && this.sendto !=='' && this.contact !== ''){
                return true;
            }
            return false;
        },
        has_text: function(){
            if(this.mail_text === '' || (!this.send_review && !this.send_tipshost)){
            return "warning";
            } else {
            return "primary";
            }
        }
    },
    methods: {
        open(review) {
            this.loading = false;
            //console.log(JSON.stringify(review));
            this.dialog = true;
            this.contacts = [];
            this.review_texts = [];
            this.review_tips = [];
            this.review = review;
            this.sendto = '';
            this.sendtolng = '';
            this.send_review = false;
            this.send_tipshost = false;
            this.contact = '';
            this.mail_subject = '';
            this.sender_address = 'aftercare@villaforyou.com';
            this.display_review = '';
            this.display_tips = '';
            this.mail_text = '';
            this.mail_text_html = '';
            this.mail_review_html = '';
            this.mail_tip_html = '';
            this.getContacts();
            this.getTexts(this.review.table, this.review.encrid, 'GuestBook');
            this.getTexts(this.review.table, this.review.encrid, 'TipsForHost');
            this.display_review = review.gastenboek;
            this.display_tips = review.tips_host;
        },    
        notifyParent(param) {
            bus.$emit("sendReview", param);
        },            
        closeDialog() {
            this.dialog = false; // close dialog
        },
        convertTextToHtml(text) {
            return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
        },
        getContactEmail(){
            var idx = this.findWithAttr(this.contacts, "eign_code", this.contact); // code, name zoeken in, naar, met waarde
            if(idx!==-1){
                this.sendto = this.contacts[idx].eign_email;
            } else {
                this.sendto = '';
            }
        },
        getContactEmailSubject(){
            var idx = this.findWithAttr(this.contacts, "eign_code", this.contact); // code, name zoeken in, naar, met waarde
            if(idx!==-1){
                this.mail_subject = this.contacts[idx].mail_subject;
            } else {
                this.mail_subject = '';
            }
        },        
        getTextinLanguage(){
            var idx = this.findWithAttr(this.contacts, "eign_code", this.contact); // code, name zoeken in, naar, met waarde
            if(idx!==-1){
                this.sendtolng = this.contacts[idx].eign_taal;
            } else {
                this.sendtolng = '';
            }
        },
        getContactLanguage(){
            var idx = this.findWithAttr(this.contacts, "eign_code", this.contact); // code, name zoeken in, naar, met waarde
            if(idx!==-1){
                this.sendtolng = this.contacts[idx].eign_taal;
                // get the correct texts
                idx = this.findWithAttr(this.review_texts, "language", this.sendtolng);             
                if(idx!==-1){
                    this.display_review = this.review_texts[idx].text;
                    if(this.review.table==='hogr'){
                        idx = this.findWithAttr(this.review_tips, "language", this.sendtolng); 
                        if(idx!==-1){
                            this.display_tips = this.review_tips[idx].text;
                        }
                    }
                }                
            } else {
                this.sendtolng = '';
            }
        },        
        sendReview(mail) {
            if(mail){
                this.loading = true;
            }
            this.mail_text_html = this.convertTextToHtml(this.mail_text);
            this.mail_review_html = this.convertTextToHtml(this.display_review);
            this.mail_tips_html = this.convertTextToHtml(this.display_tips);
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/sendReview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendReview",
                    },
                    sendReview: {
                        review: this.review,
                        mail_address_recipient: this.sendto,
                        mail_recipient: this.contact,
                        language: this.sendtolng,
                        sender: this.sender_address,
                        subject: this.mail_subject,
                        review_text_lng: this.mail_review_html,
                        tips_text_lng: this.mail_tips_html,
                        mail_text_lng: this.mail_text_html,
                        print_review: this.send_review,
                        print_tip: this.send_tipshost, 
                        preview: !mail,    
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        console.log(JSON.stringify(res.data));
                        try {
                            if (res.data.header.preview_url !== '') {
                                this.previewFileByUrl(res.data.header.preview_url);
                            } else {
                                this.notifyParent(1); // add 1 to badge
                                this.closeDialog();
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    }
                })
                .finally(() => { this.loading = false; });    
        },

        getContacts(){
            //console.log("get acco contacts");
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getReviewContacts.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReviewContacts",
                    },
                    getReviewContacts: {
                        huis_encrid: this.review.huis_encrid,                   
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        //console.log(JSON.stringify(res.data));
                        this.contacts = res.data.getReviewContacts;
                    }
                })
                .finally(() => {});    
        },
        previewFileByUrl(url){
            window.open(url,'_blank');
        },             
        getTexts(table, encrid, type) {
            if(table==='revw' && type==='TipsForHost'){
                return;
            }
            //console.log(table, encrid, type);
            this.$axios
                .post("ares/json/ares/huis/revw/getReviewTexts.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReviewTexts"
                    },
                    getReviewTexts: {
                        table: table,
                        encrid: encrid,
                        type: type,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        //console.log(JSON.stringify(res.data.getReviewTexts.Texts));
                        if(type==='GuestBook'){
                            this.review_texts = res.data.getReviewTexts.Texts;
                        }else{
                            this.review_tips = res.data.getReviewTexts.Texts;
                        }
                    }
                })
                .finally(() => {
                });
        },        
    }
}
</script>

<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-webkit-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-o-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    } 

    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 325px;
        overflow-y: auto;
    }    
    .row-pointer {
        cursor: default;
    }
    .subtitle{
       color: gray;
       font-size: 11.5px;
       font-weight: 300;       
    }
</style>